module.exports = __webpack_public_path__ + "img/i-link.a02b4cfc.svg";